export default {
  modelName: 'checklist_conclusion_daily_template',
  versionModelName: 'checklist_template_version',
  label: '每日點檢表公版',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    frequency: {
      type: 'select',
      label: '頻率',
      items: [
        {
          text: '日',
          value: 'day',
        },
        {
          text: '週',
          value: 'week',
        },
        {
          text: '月',
          value: 'month',
        },
        {
          text: '季',
          value: 'season',
        },
      ],
      defaultValue: 'day',
    },
    industry_categories: {
      label: '適用產業別',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'industry_category',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: true,
      activeText: '啟用中',
      inactiveText: '停用',
    },
    last_version: {
      type: 'last_version',
      label: '版本列表',
      modelName: 'checklist_template_version',
      showFields: ['name_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          // label: "多語言內容",
          fields: {
            name: {
              type: 'text',
              label: '名稱',
              rules: 'required',
              maxlength: 30,
            },
            remark: {
              type: 'text',
              label: '備註',
              maxlength: 1000,
            },
          },
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          textKey: 'name',
          readonly: true,
        },
        updated_at: {
          type: 'datetime',
          label: '更新時間',
          readonly: true,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    area: {
      label: '適用地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area',
      rules: 'required',
    },
    system_class: {
      label: '領域',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_class',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_class',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
